import { zodResolver } from "@hookform/resolvers/zod";
import { IconCliffJumping, IconUserPlus } from "@tabler/icons-react";
import { useEffect, useMemo, useState, useCallback } from "react";
import { Button, Col, Offcanvas, Row } from "react-bootstrap"
import { useForm, useWatch } from "react-hook-form";
import { datetimeRegex, pipeline, z } from "zod"
import { baseURL } from "../../../Utils/constants/constant";
import {
    DateField,
    Text,
    SelectOpt,
    ReportSelectOpt
} from "../../../CommonComponents/FieldComp";
import { GetRequest } from "../../../Utils/hooks/ApiHandler";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import { getStates, getCities } from "../../../Utils/hooks/location"
import useLocalStorageState from "use-local-storage-state";
import { formatDate } from "../../../Utils/helpers/commonhelper";

const generateTableData = (filterName, data) => {
    const normalizedFilter = filterName?.toLowerCase().replace(/\s+/g, '_');
    let leadsData = []
    let dealsData = []
    let contactData = []
    let companyData = []
    let quotationData = []
    let purchaseData = []
    let salesData = []
    if (normalizedFilter === "leads") {
        leadsData = data?.map(item => {
            const productsArr = JSON.parse(item.product_services) || []
            const totalBudget = Array.isArray(productsArr) && productsArr?.reduce((acc, curr) => acc + (parseFloat(curr?.budget) || 0), 0) || 0;
            return {
                name: item.contact_full_name || '-',
                lead_id: item.lead_no,
                phone: item.user_phone && JSON.parse(item.user_phone)[0].phone || '-',
                email: item.email?.toLowerCase() || '-',
                budget: totalBudget || '-',
                requirement: item.requirement || '-',
                service: item.service || '-',
                source: item.source_title || '-',
                expected_closure_date: formatDate(item.expected_closure_date) || '-',
                lead_status: item.lead_status || '-'
            }
        })
        return leadsData
    }
    else if (normalizedFilter === "deals") {
        dealsData = data?.map(item => {
            const productsArr = JSON.parse(item.product_services) || []
            const totalBudget = Array.isArray(productsArr) && productsArr?.reduce((acc, curr) => acc + (parseFloat(curr?.budget) || 0), 0) || 0;
            return {
                name: item.contact_full_name || '-',
                phone: item.user_phone && JSON.parse(item.user_phone)[0].phone || '-',
                email: item.email || '-',
                budget: totalBudget || '-',
                requirement: item.requirement || '-',
                service: item.service || '-',
                source: item.source_title || '-',
            }
        })
        return dealsData
    }
    else if (normalizedFilter === "contact") {
        contactData = data?.map(item => ({
            name: item.contact_full_name || '-',
            email: item.email || '-',
            contact: item.contact_no || '-',
            owner: item.owner_name || '-',
            report_to: item.report_to || '-',
            company_name: item.company_name || '-',
            designation: item.designation || '-',
            department: item.department || '-',
            decision_maker: item.decision_maker || '-',
            city: item.city_name || '-',
            state: item.state_name || '-',
            country: item.country || '-',
            zipcode: item.zipcode || '-',
            lead_source: item.source_title || '-',
            tags: item.tags && JSON.parse(item.tags).forEach(i => i) || '-',
            notes: item.note || '-'
        }))
        return contactData
    }
    else if (normalizedFilter === "company") {
        companyData = data?.map(item => ({
            name: item.company_name || '-',
            website: item.website || '-',
            industry: item.industry || '-',
            business_type: item.business_type || '-',
            owner: item.owner_name || '-',
            email: item.email || '-',
            address: item.address || '-',
            state: item.state_name || '-',
            city: item.city_name || '-',
            zipcode: item.zipcode || '-'
        }))
        return companyData
    }
    else if (normalizedFilter === "quotation") {
        quotationData = data?.map(item => {
            return {
                quotation_number: item.quotation_number || '-',
                contact: item.contact_full_name || '-',
                contact_no: item.user_phone && JSON.parse(item.user_phone)[0].phone || '-',
                company: item.company || '-',
                quotation_date: item.quotation_date || '-',
                expiry_date: item.expiry_date || '-',
                lead_owner: item.lead_owner || '-',
                deal: item.deal || '-',
                quotation_status: item.quotation_status || '-'
            }
        })
        return quotationData
    }
    else if (normalizedFilter === "purchase_order") {
        purchaseData = data?.map(item => ({
            po_no: item.po_number || '-',
            po_to: item.contact_full_name || '-',
            company_name: item.company_name || '-',
            po_generated_by: item.owner_name || '-',
            issued_date: formatDate(item.po_date) || '-',
            status: item.status || '-'
        }))
        return purchaseData
    }
    else if (normalizedFilter === "sales_order") {
        salesData = data?.map(item => {
            const productsArr = JSON.parse(item.items) || []
            const totalBudget = Array.isArray(productsArr) && productsArr?.reduce((acc, curr) => acc + (parseFloat(curr?.amount) || 0), 0) || 0;
            return {
                date: item.date || '-',
                sales_order: item.sale_no || '-',
                reference: item.reference || '-',
                customer_name: item.contact_full_name || '-',
                status: item.status || '-',
                invoiced: item.invoiced || '-',
                payment: item.payment || '-',
                amount: totalBudget || '-',
                expected_shipment_date: formatDate(item.shipment_date) || '-',
                order_status: item.order_status || 'Delivered',
                delivery_method: item.delivery_method || 'By Road'
            }
        })
        return salesData
    }

    return []
}
export const ReportOffcanvas = ({ onHide, show, module_name, schemaFields, duration, setTableData, tableRef, setSelectedModule }) => {

    const capitalizedModuleName = module_name.split("")[0].toUpperCase() + module_name.slice(1)
    //  Getting customer info from session storage
    const [customer, setCustomer] = useLocalStorageState("customer");

    //  Local states for managing designation data, errors, and loading state
    const navigate = useNavigate();

    //Auth headers for API requests
    const customerId = customer?.customer_details?.customer_id;
    const userID = customer?.customer_details?.id;

    const token = customer?.token?.authorization;
    const rf = customer?.token?.authentication;
    const headers = {
        authentication: rf,
        Authorization: token,
    };

    const extras = { customer, setCustomer, rf, navigate };
    const [isLoading, setIsLoading] = useState(false);

    // function to set the dynamic fields for the dynamic fields
    const generateDynamicSchema = (fields) => {
        const schemaFields = {};
        fields.forEach((field) => {
            const fieldId = field.id;
            switch (field.label_type) {
                case "text":
                    schemaFields[fieldId] =
                        field.is_required === "yes"
                            ? z.string().min(1, `${field.label_name} is required`)
                            : z.string().optional();
                    break;
                case "single-option":
                    schemaFields[fieldId] =
                        field.is_required === "yes"
                            ? z.string().min(1, `${field.label_name} is required`)
                            : z.string().optional();
                    break;
                case "date":
                    schemaFields[fieldId] =
                        field.is_required === "yes"
                            ? z.string().min(1, `${field.label_name} is required`)
                            : z.string().optional();
                    break;
                case "date-range":
                    schemaFields[fieldId] =
                        field.is_required === "yes"
                            ? z
                                .object({
                                    start: z.string().min(1, "Start date is required"),
                                    end: z.string().min(1, "End date is required"),
                                })
                                .refine((data) => data.start <= data.end, {
                                    message: "End date must be after start date",
                                })
                            : z
                                .object({
                                    start: z.string().optional(),
                                    end: z.string().optional(),
                                })
                                .optional();
                    break;
                default:
                    schemaFields[fieldId] = z.any().optional();
            }
        });
        return z.object(schemaFields);
    };

    const finalSchema = useMemo(() => {
        if (schemaFields?.length === 0 || !schemaFields) return z.object({}); // Return empty schema instead of undefined
        const dynamicSchema = generateDynamicSchema(schemaFields);
        return dynamicSchema;
    }, [schemaFields]); // Add dependency

    const [leadSource, setLeadSource] = useState([])
    const [company, setCompany] = useState([])
    const [lead_owner, setLeadOwner] = useState([])
    const [state, setState] = useState([])
    const [city, setCity] = useState([])
    const [contactOptions, setContactOptions] = useState([])

    const [availablePipelines, setAvailablePipelines] = useState([])
    const [pipelineStage, setPineLineStage] = useState([])
    const [selectedPipelineId, setSelectedPipelineId] = useState()
    const [quotation, setQuotation] = useState([])
    const [products, setProducts] = useState([])

    const {
        handleSubmit, register, control, reset, setValue, watch, getValues
    } = useForm({
        resolver: finalSchema ? zodResolver(finalSchema) : undefined, // Handle case when finalSchema is undefined
    })

    // just to ensure that no unnecessary useeffects will get called if the respective field is not passed
    const hasField = useCallback((identifier) => {
        return schemaFields?.some(field => {
            return field.id === identifier ||
                field.label_name?.toLowerCase().includes(identifier)
        }
        );
    }, [schemaFields]);

    // array state for lead_status
    const lead_status = [
        { value: "won", label: "Won" },
        { value: "lost", label: "Lost" },
        { value: "unqualified", label: "Unqualified" },
    ]
    // array state for industry 
    const industryOptions = [
        { value: "Technology", label: "Technology" },
        { value: "Healthcare", label: "Healthcare" },
        { value: "Finance", label: "Finance" },
        { value: "Education", label: "Education" },
        { value: "Manufacturing", label: "Manufacturing" },
        { value: "Retail", label: "Retail" },
        { value: "Real Estate", label: "Real Estate" },
        { value: "Construction", label: "Construction" },
        { value: "Transportation", label: "Transportation" },
        { value: "Food & Beverage", label: "Food & Beverage" },
        { value: "Entertainment", label: "Entertainment" },
        { value: "Consulting", label: "Consulting" },
        { value: "Marketing & Advertising", label: "Marketing & Advertising" },
        { value: "Legal Services", label: "Legal Services" },
        { value: "Insurance", label: "Insurance" },
        { value: "Telecommunications", label: "Telecommunications" },
        { value: "Energy", label: "Energy" },
        { value: "Agriculture", label: "Agriculture" },
        { value: "Automotive", label: "Automotive" },
        { value: "Aerospace", label: "Aerospace" },
        { value: "Pharmaceuticals", label: "Pharmaceuticals" },
        { value: "Banking", label: "Banking" },
        { value: "E-commerce", label: "E-commerce" },
        { value: "Media", label: "Media" },
        { value: "Non-profit", label: "Non-profit" },
        { value: "Government", label: "Government" },
        { value: "Hospitality", label: "Hospitality" },
        { value: "Travel & Tourism", label: "Travel & Tourism" },
        { value: "Sports & Recreation", label: "Sports & Recreation" },
        { value: "Beauty & Wellness", label: "Beauty & Wellness" },
    ];
    // array state for buisness type 
    const businessTypeOptions = [
        { value: "Sole Proprietorship", label: "Sole Proprietorship" },
        {
            value: "Limited Liability Partnership(LLP)",
            label: "Limited Liability Partnership(LLP)",
        },
        { value: "Private Limited Company", label: "Private Limited Company" },
        { value: "Public Limited Company", label: "Public Limited Company" },
    ];

    // array for date type options
    const dateTypeOpt = [
        { value: "created_at", label: "Created At" },
        { value: "followup_date", label: "FollowUp Date" }
    ]

    // useEffect for lead owner
    useEffect(() => {
        if (!hasField('owner_id')) return;
        (async () => {
            const res = await GetRequest(
                `users/users/fetchUserAsOwner/${customerId}`,
                { headers },
                extras
            );
            const owners =
                res.data &&
                res.data.map((lead) => ({
                    label: lead.full_name,
                    value: lead.id,
                }));
            setLeadOwner(owners);
            if (owners && owners.length > 0 && schemaFields?.some(field => field.id === `${capitalizedModuleName}-owner_id`) && Number(customer.customer_details?.user_type) !== 1) {
                setValue(`${capitalizedModuleName}-owner_id`, customer?.customer_details?.id);
            }
        })();
    }, [customerId, customer?.customer_details?.id, schemaFields, setValue]);

    // useEffect for lead source
    useEffect(() => {
        if (!hasField('lead_source')) return;
        (async () => {
            const res = await GetRequest(
                `masters/getAllLead_source/${customer.customer_details?.customer_id}`,
                { headers },
                extras
            );
            if (!res) return;
            if (res.success === false) {
                return;
            }
            setLeadSource(
                res.data.map((lead) => ({
                    label: lead.source_title,
                    value: lead.id,
                }))
            );
        })();
    }, [customer.customer_details?.customer_id]); // Add dependency

    // useEffect for company
    useEffect(() => {
        if (!hasField('company')) return;
        (async () => {
            const res = await GetRequest(
                `company/fetchCompanies/${customerId}`,
                { headers },
                extras
            );
            if (!res) return;
            if (res.success === false) {
                return;
            }
            const companyData = res.data.map((c) => ({
                label: c.company_name,
                value: c.id,
            }))
            setCompany(companyData);
        })();
    }, [customerId]); // Add dependency

    // useEffect for pipeline
    useEffect(() => {
        if (!hasField('pipeline_id')) return;
        const fetchPipelines = async () => {
            try {
                const res = await GetRequest(
                    `/lead/fetchPipelines_dropdown/${customerId}/${module_name.toLowerCase()}/${customer.customer_details?.id}/${customer.customer_details?.user_type}`,
                    { headers },
                    extras
                );
                if (res.status === "fail" || res.success === false) {
                    return;
                }

                const pipelineData = res.data?.map(c => ({
                    value: c.id,
                    label: c.pipeline_name
                }))
                setAvailablePipelines(pipelineData);

                // Only set default pipeline if no pipeline is selected and it's not edit mode
                if (!selectedPipelineId && res.data?.length > 0) {
                    const activePipeline =
                        res.data.find((p) => p.is_active === "yes") || res.data[0];
                    setSelectedPipelineId(activePipeline.id);
                }
            } catch (error) {
                return
            }
        };
        if (module_name?.toLowerCase() === "leads" || module_name?.toLowerCase() === "deals") {
            fetchPipelines();
        }
        return;
    }, [module_name, selectedPipelineId])

    // useEffect for pipeline stage
    const pipelineId = watch(`${capitalizedModuleName}-pipeline_id`)
    useEffect(() => {
        if (!hasField('pipeline_id')) return;
        const fecthPipeLineStage = async () => {
            try {
                let pipelineIdToUse;
                if (pipelineId) {
                    pipelineIdToUse = pipelineId
                } else {
                    pipelineIdToUse = selectedPipelineId
                }
                const res = await GetRequest(`/lead/fetchPipelineStage/${pipelineIdToUse}/${customerId}`, { headers }, extras)
                if (res.status === "success") {
                    const stageData = res.data?.map(c => ({
                        value: c.id,
                        label: c.stage_name
                    }))
                    setPineLineStage(stageData)
                }

                pipelineId === undefined || pipelineId === null || pipelineId === "" && setValue(`${capitalizedModuleName}-pipeline_stage_id`, '')
            } catch (err) {
                console.error("Failed to fetch pipeline stages:", err)
            }
        }
        if (module_name?.toLowerCase() === "leads" || module_name?.toLowerCase() === "deals") {
            fecthPipeLineStage()
        }
        return
    }, [pipelineId, customerId, module_name, selectedPipelineId, setValue])

    // useEffect for contact
    useEffect(() => {
        if (!hasField('contact_id')) return;
        const fetchContactNames = async () => {
            const res = await GetRequest(
                `lead/getContactsForLeads/${customerId}/${customer.customer_details?.id}/${customer.customer_details?.user_type}`,
                headers,
                extras
            );

            if (res.status === "success") {
                const data = res.data.map((contactName) => ({
                    value: contactName.id,
                    label: contactName.contact_full_name,
                }));
                setContactOptions(data);
            }
        };
        fetchContactNames();
    }, [customerId, userID]);

    // useEffect for state
    useEffect(() => {
        if (!hasField('state')) return;
        const fetchStates = async () => {
            try {
                const data = await getStates("99")
                if (data) {
                    const stateData = data.map((s) => ({
                        label: s.state_name,
                        value: s.id,
                    }))
                    setState(stateData)
                }
                setValue(`${capitalizedModuleName}-state`, "");
            } catch (err) {
                // Error handling
                return
            }
        }
        fetchStates()
    }, [setValue, capitalizedModuleName])

    // useEffect for city
    const stateId = watch(`${capitalizedModuleName}-state`)
    useEffect(() => {
        if (!hasField('city')) return;
        (async () => {
            try {
                if (!stateId || stateId === "") {
                    setCity([]);
                    setValue(`${capitalizedModuleName}-city`, "");
                    return;
                }
                const data = await getCities(stateId);
                if (!data || data === undefined) {
                    setCity([]);
                    return;
                }
                setCity(
                    data.map((city) => ({
                        label: city.city_name,
                        value: city.id,
                    }))
                );
                setValue(`${capitalizedModuleName}-city`, "");
            } catch (error) {
                toast.error("Error Fetching State");
                return;
            }
        })();
    }, [stateId, setValue, capitalizedModuleName]);

    // useEffect for product and services
    useEffect(() => {
        if (!hasField('product_services')) return;
        const fetchProducts = async () => {
            try {
                const res = await GetRequest(
                    `masters/getProducts/${customerId}`,
                    { headers },
                    extras
                );
                if (res?.data) {
                    const products = res.data?.map(c => ({
                        value: c.id,
                        label: c.service
                    }))
                    setProducts(products)
                }
            } catch (error) {
                return
            }
        };

        if (module_name === "Leads" || module_name === 'Deals' || module_name === "Purchase_Order" || module_name === "Quotation" || module_name === "Sales_Order") {
            fetchProducts()
        }
        return
    }, [module_name])

    // useeffect for quotation data fetching
    useEffect(() => {
        if (!hasField('quotation_id')) return;
        const fetchQuotation = async () => {
            try {
                const res = await GetRequest(
                    `quotation/fetchQuotation/${customerId}/${customer.customer_details?.id}//${customer?.customer_details?.user_type}`,
                    { headers },
                    extras
                );
                if (res?.data) {
                    const quotations = res.data?.map(c => ({
                        value: c.quotation_id,
                        label: c.quotation_number
                    }))
                    setQuotation(quotations)
                }
            } catch (error) {
                return
            }
        };
        fetchQuotation()
    }, [])

    const mutateSchemaFieldsWithOptions = useCallback((fields) => {
        return fields?.map(field => {
            const mutatedField = { ...field };
            if (field.label_type === 'single-option') {

                // Map specific fields to their respective options based on field name or id
                const fieldIdentifier = field.label_name?.toLowerCase()
                if (fieldIdentifier.includes('lead_source_id')) {
                    mutatedField.options = leadSource
                    mutatedField.fieldName = "Lead Source"
                }
                else if (fieldIdentifier.includes('company_id')) {
                    mutatedField.options = company
                    mutatedField.fieldName = "Company"
                }
                else if (fieldIdentifier.includes('owner_id')) {
                    mutatedField.options = lead_owner
                    mutatedField.fieldName = "Lead Owner"
                }
                else if (fieldIdentifier.includes('approver_id')) {
                    mutatedField.options = lead_owner
                    mutatedField.fieldName = "Approver Id"
                }
                else if (fieldIdentifier.includes('state')) {
                    mutatedField.options = state
                    mutatedField.fieldName = "State"
                }
                else if (fieldIdentifier.includes('city')) {
                    mutatedField.options = city
                    mutatedField.fieldName = "City"
                }
                else if (fieldIdentifier.includes('contact_id')) {
                    mutatedField.options = contactOptions;
                    mutatedField.fieldName = "Contact"
                }
                else if (fieldIdentifier === 'pipeline_id') {
                    mutatedField.options = availablePipelines
                    mutatedField.fieldName = "Pipeline"
                }
                else if (fieldIdentifier.includes('pipeline_stage_id')) {
                    mutatedField.options = pipelineStage
                    mutatedField.fieldName = "Pipeline Stage"
                }
                else if (fieldIdentifier.includes('product_services')) {
                    mutatedField.options = products
                    mutatedField.fieldName = "Products"
                }
                else if (fieldIdentifier.includes('lead_status')) {
                    mutatedField.options = lead_status;
                    mutatedField.fieldName = "Lead Status"
                }
                else if (fieldIdentifier.includes('industry')) {
                    mutatedField.options = industryOptions;
                    mutatedField.fieldName = "Industry"
                }
                else if (fieldIdentifier.includes('business_type')) {
                    mutatedField.options = businessTypeOptions;
                    mutatedField.fieldName = "Buisness Type"
                }
                else if (fieldIdentifier.includes('date-type')) {
                    mutatedField.options = dateTypeOpt;
                }
                else if (fieldIdentifier.includes('quotation_id')) {
                    mutatedField.options = quotation;
                    mutatedField.fieldName = "Quotation Number"
                }
                else {
                    mutatedField.options = [];
                }
            }
            return mutatedField;
        });
    }, [leadSource, company, lead_owner, state, city, contactOptions, availablePipelines, pipelineStage, products, quotation]); // Add all dependencies

    useEffect(() => {
        const currentDate = new Date();
        if (duration === null || duration === undefined) return;

        const formatDate = (date) => {
            return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 12, 0, 0)
                .toISOString().split('T')[0];
        };

        if (duration === "t_month") {
            const firstDay = new Date(currentDate.getFullYear(), currentDate.getMonth() - 3, 1);
            const lastMonthDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);
            console.log("firstDay", firstDay, "lastmonth", lastMonthDay)
            setValue(`${capitalizedModuleName}-date`, { start: formatDate(firstDay), end: formatDate(lastMonthDay) });
        }
        else if (duration === "c_month") {
            const firstDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
            const todaysDate = new Date(currentDate);
            setValue(`${capitalizedModuleName}-date`, { start: formatDate(firstDay), end: formatDate(todaysDate) });
        }
        else if (duration === "l_month") {
            const firstDay = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);
            const lastDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);
            setValue(`${capitalizedModuleName}-date`, { start: formatDate(firstDay), end: formatDate(lastDay) });
        }
    }, [duration]);

    const mutatedFields = useMemo(() => {
        return mutateSchemaFieldsWithOptions(schemaFields)
    }, [schemaFields, mutateSchemaFieldsWithOptions])


    const dateType = watch(`${capitalizedModuleName}-is_followup`)
    useEffect(() => {
        if (duration) return
        if (dateType === undefined || dateType === "") {
            setValue(`${capitalizedModuleName}-date`, { start: "", end: "" })
        }
    }, [dateType, setValue, duration, capitalizedModuleName])

    const allData = watch()
    // to pass the current state of datetype
    const date = useWatch({ control, name: `${capitalizedModuleName}-is_followup` })

    const handleGo = async () => {
        if (isLoading) return;
        setIsLoading(true);
        try {
            let queryString = `duration=${duration !== null ? duration : ""}`;
            queryString += `&search=${allData[`${capitalizedModuleName}-search`] || ""}`
            schemaFields?.forEach((c) => {
                if (c.label_name.toLowerCase() !== "date" &&
                    c.label_name.toLowerCase() !== "search" &&
                    c.label_name.toLowerCase() !== "is_followup") {
                    queryString += `&${c.label_name}=${allData[c.id] === undefined ? "" : allData[c.id]}`;
                }
            });
            if (duration === null) {
                if (date === 'created_at') {
                    queryString += `&start_date=${allData[`${capitalizedModuleName}-date`]?.start || ""}`;
                    queryString += `&end_date=${allData[`${capitalizedModuleName}-date`]?.end || ""}`;
                } else if (date === "followup_date") {
                    queryString += `&closure_date_start=${allData[`${capitalizedModuleName}-date`]?.start || ""}`;
                    queryString += `&closure_date_end=${allData[`${capitalizedModuleName}-date`]?.end || ""}`;
                }
            }
            const res = await GetRequest(`report/fetchReportSBasedOnDurationAndModule/${customerId}/${module_name.toLowerCase().split(" ").join("_")}/${customer?.customer_details?.id}?${queryString}`, { headers }, extras)
            if (res.success === false) {
                toast.error(res.message)
                return
            }
            if (res.status === "fail") {
                toast.error(res.message)
            }
            // generating the table data and its corresponding headers and setting the table data
            const tabledata = generateTableData(module_name, res.data)
            setTableData(tabledata)
            onHide()
            // Scroll to table after data is set
            setTimeout(() => {
                tableRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 100);
        } catch (error) {
            return;
        } finally {
            setIsLoading(false);
        }
    }

    return (
        <Offcanvas
            className="reportOffcanvas w-50"
            placement="end"
            backdrop="static"
            enforceFocus={true}
            show={show}
            onHide={onHide}
        >
            <Offcanvas.Header
                closeButton
                className="border-bottom border-dashed pt-3 "
            >
                <div className="d-flex align-items-center gap-2">

                    <div className="pt-3">
                        <Offcanvas.Title style={{ color: "#7a3a5e", textTransform: "capitalize" }}>
                            {module_name.split("_").join(" ")} Report
                        </Offcanvas.Title>
                        <p
                            style={{ fontSize: "14px", color: "#b26792" }}
                            className=" text-secondary text-nowrap"
                        >
                            Please Edit Report here, fill all the mandatory fields and submit.
                        </p>
                    </div>
                </div>
            </Offcanvas.Header>
            <Offcanvas.Body>
                {isLoading && (
                    <div className="spinner-overlay">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                )}
                <Row className="w-100 ms-0 mt-3 form-container" style={{ paddingLeft: "0px" }}>
                    {schemaFields &&
                        mutatedFields.length !== 0 &&
                        mutatedFields.map((field) => {
                            // console.log(object)
                            return (
                                <>
                                    {field.label_type === "text" && (
                                        <Col md={12}>
                                            <Text
                                                name={field.id}
                                                label_name={field.label_name}
                                                label_type={field.label_type}
                                                control={control}
                                            />
                                        </Col>
                                    )}

                                    {field.label_type === "single-option" && (
                                        <Col md={6}>
                                            <ReportSelectOpt
                                                name={field.id}
                                                label_name={field.label_name}
                                                label_type={field.label_type}
                                                control={control}
                                                options={field.options !== null && field.options}
                                                fieldName={field.fieldName}
                                                placeholder={`Select ${field.label_name?.split("_")?.join(" ")}`}
                                            />
                                        </Col>
                                    )}

                                    {field.label_type === "date" && (
                                        <Col md={6}>
                                            <DateField
                                                name={field.id}
                                                label_name={field.label_name}
                                                label_type={field.label_type}
                                                control={control}
                                            />
                                        </Col>
                                    )}
                                    {field.label_type === "date range" && (
                                        <Col md={6}>
                                            <DateField
                                                name={field.id}
                                                label_name={field.label_name}
                                                label_type={field.label_type}
                                                control={control}
                                                isDisabled={date !== undefined && date !== "" ? false : true}
                                            />
                                        </Col>
                                    )}
                                </>
                            );
                        })}
                </Row>
                <div style={{ height: "80px", marginBottom: "40px" }}></div>
                {/* save and cancel button */}
                <div
                    style={{
                        position: "fixed",
                        width: "50%",
                        bottom: 0,
                        height: "74px",
                        zIndex: 50,
                        right: 0,
                        background: "#fefefe",
                        paddingRight: "20px",
                        borderTop: "1px solid #c4ebf7",
                    }}
                >
                    <div className="d-flex justify-content-end gap-2 pt-4">
                        <Button
                            className="btn btn-default"
                            variant="action-btn"
                            style={{ width: "90px" }}
                            onClick={handleGo}
                            disabled={isLoading}
                        >
                            {isLoading ? (
                                <>
                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                    Loading...
                                </>
                            ) : (
                                "Go"
                            )}
                        </Button>
                    </div>
                </div>
            </Offcanvas.Body>
        </Offcanvas>
    )
}